import { EntityTypes } from "../../EntityTypes";
import { IApiMutationFunction, createApiMutationHook } from "../../utils/api";
import { RelationalValue, mapRelationalValue } from "../../utils/filters";
import { buildResourceIRI } from "../../utils/getResourceUuid";
import { IUserResource, IUserSettings } from "../types";

export interface IUserSettingsUpdateParameters {
    user: RelationalValue<IUserResource>;
    homecards: IUserSettings["homecards"];
    dismissedAnnouncementUuid?: IUserSettings["dismissedAnnouncementUuid"];
}

export type IUserSettingsUpdateMutationResult = IUserSettings;

export const userSettingsUpdateMutation: IApiMutationFunction<IUserSettingsUpdateParameters> = ({
    user,
    homecards,
    dismissedAnnouncementUuid,
}) => {
    const userId = mapRelationalValue(user);

    return {
        method: "PUT",
        url: `/user_settings/${userId}`,
        data: {
            user: buildResourceIRI(EntityTypes.USER, user),
            homecards,
            dismissedAnnouncementUuid,
        },
    };
};

export const useUserSettingsUpdateMutation = createApiMutationHook<
    IUserSettingsUpdateParameters,
    IUserSettingsUpdateMutationResult
>(userSettingsUpdateMutation);
